import { render, staticRenderFns } from "./MasterDetail.vue?vue&type=template&id=515e8084"
import script from "./MasterDetail.vue?vue&type=script&lang=js"
export * from "./MasterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports